module.exports = __webpack_public_path__ + "1f21ac83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/icon-warehouse-transport.png
// module id = 1540
// module chunks = 0